import { GlobalServiceService } from 'src/app/services/global-service.service';
import { LocalstorageService } from './../services/localstorage.service';
import { Injectable } from '@angular/core';
import { ApiBasic } from '../services/api-basic';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private httpOptions = {
    headers: new HttpHeaders(

      {
        'Content-Type': 'application/json',

      }
    )
  }
  appBase
  private token = ""
  subscription: Subscription;
  constructor(
    public http: HttpClient,
    public api: ApiBasic,
    public _global: GlobalServiceService,
    private _localstorage: LocalstorageService,
  ) {
    // this._global.base_url = this._global.base_url
    this.token = _global.token
    this.subscription = this._localstorage.getToken().subscribe(message => {
      this.token = _global.token
    });
  }

  public getUsers(user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    return this.http.get(this._global.base_url + "/users?user_id=" + user_id, httpOptions)
  }

  public getUsersRefactions() {
    return this.http.get(this._global.base_url + "/refacciones/usuariosv2Refacciones", {})
  }

  public createUser(data, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(this._global.base_url + "/users?user_id=" + user_id, data, httpOptions)

  }

  public catalogDeptos() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/catalogs/departments", httpOptions)
  }

  public catalogPositions() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/catalogs/positions", httpOptions)
  }

  public catalogRoles() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/catalogs/roles", httpOptions)
  }

  public getDetailUser(id_item, user_id) {


    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    return this.http.get(this._global.base_url + "/users/" + id_item + "?user_id=" + user_id, httpOptions)
  }

  public deleteUser(id_item, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.delete(this._global.base_url + "/users/" + id_item + "?user_id=" + user_id, httpOptions)
  }

  public editUser(id_item, user_id, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };

    return this.http.patch(this._global.base_url + "/users/" + id_item + "?user_id=" + user_id, data, httpOptions)
  }

  public getRoles(user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/roles?user_id=" + user_id, httpOptions)
  }

  public getDetailRol(id_item, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/roles/" + id_item + "?user_id=" + user_id, httpOptions)
  }

  public createRole(data, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(this._global.base_url + "/roles?user_id=" + user_id, data, httpOptions)

  }

  public deleteRol(id_item, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.delete(this._global.base_url + "/roles/" + id_item + "?user_id=" + user_id, httpOptions)
  }

  public editRol(id_item, user_id, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.patch(this._global.base_url + "/roles/" + id_item + "?user_id=" + user_id, data, httpOptions)

  }

  public createModulo(data, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(this._global.base_url + "/modules?user_id=" + user_id, data, httpOptions)

  }

  public getDetailModulo(id_item) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/modules/" + id_item, httpOptions)
  }

  public editModulo(id_item, user_id, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.patch(this._global.base_url + "/modules/" + id_item + "?user_id=" + user_id, data, httpOptions)

  }

  public deleteModulo(id_item, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.delete(this._global.base_url + "/modules/" + id_item + "?user_id=" + user_id, httpOptions)
  }

  public getCatalog(data: any, catalog: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    var queryData = this.api.stringfyObject(data)
    return this.http.get(this._global.base_url + "/catalogs" + catalog + "?" + queryData, httpOptions)
  }

  public getAllUsers(user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/all-users?user_id=" + user_id, httpOptions)
  }

  public changeStatusBloqueo(user, flag_bloqueo) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + '/bloquearuser/' + user + '?flag_bloqueo=' + flag_bloqueo, httpOptions)
  }

  public changeStatusActivo(user, activo) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + '/activacionuser/' + user + '?activo=' + activo, httpOptions)
  }

  public sendToken(data) {
    return this.http.post(this._global.base_url + "/send_token_register", data, {})
  }

  public getVariablesConfig() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + '/rules/account', httpOptions)
  }

  public editVariablesConfig(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(this._global.base_url + '/rules/account', data, httpOptions)
  }

}
